import { MessageDescriptor } from 'react-intl';
import { camelize } from 'lib/utility';
import ConfigStore from 'lib/stores/configStore';
import { getIntlMessage } from './shared';
import { defaultMessages } from './default';

const getLocale = (
  page: string,
  kind: string,
  key: string,
  defaultMessage: string,
): MessageDescriptor => {
  const { intlPrefix } = ConfigStore.getRawState();
  const intlMessage = getIntlMessage(intlPrefix, page, kind, key);

  return defaultMessages[camelize(intlMessage)] || { id: intlMessage.split(' ').join('.'), defaultMessage };
};

export default getLocale;
